export const T = {
  en_GB: {
    income: "Income",
    assets: "Assets",
    liabilities: "Liabilities",
    commitments: "Commitments",
    capacity: "Capacity",
    summary: "Summary",
    incompleteMessage: "Complete your financial situation",
    expectingChangesQuestion:
      "Are you expecting any changes to your financial situation in the coming period?",
    expectingChangesNote: "Describe the expected changes",
    yes: "Yes",
    no: "No",
    depositsExceedCapacity:
      "The planned one-time deposits exceed the amount available for investments. Reduce the deposits or revise the capacity inputs.",
    recurringDepositsExceedSurplus:
      "The planned monthly deposits exceed the client's monthly surplus. Reduce the monthly savings or revise the capacity inputs.",
    requiredFieldsMissing: "Enter an amount for every required field (marked with *).",
    requiredFieldsMissingNamed: (fields: string) => `Enter an amount for: ${fields}.`,
    baselineMissing: "Enter at least one income or asset amount before continuing.",
    assetsRequired: "At least one asset with an amount is required.",
    liabilitiesRequired: "At least one liability with an amount is required.",
    expectingChangesUnanswered:
      "Answer the question about expected changes to the financial situation.",
    expectingChangesNoteMissing: "Describe the expected changes to the financial situation.",
    capacityMissing: "Fill in the Capacity tab (income and expenses).",
    bufferMissing:
      "Enter the custom liquidity buffer amount on the Capacity tab, or choose the minimum.",
    bufferBelowMinimum:
      "The liquidity buffer is below the required minimum. Increase the buffer or revise the capacity inputs.",
    fillFromEnin: "Fill from ENIN",
    fetchingFromEnin: "Fetching from ENIN…",
    eninFetchFailed: "Could not fetch figures from ENIN.",
    fromEnin: "From ENIN",
    groupNote: "The financial situation is based on the group's financial situation.",
  },
  nb_NO: {
    income: "Inntekt",
    assets: "Eiendeler",
    liabilities: "Gjeld",
    commitments: "Forpliktelser",
    capacity: "Kapasitet",
    summary: "Sammendrag",
    incompleteMessage: "Fullfør din finansielle situasjon",
    expectingChangesQuestion:
      "Forventer du endringer i din økonomiske situasjon i den kommende perioden?",
    expectingChangesNote: "Beskriv de forventede endringene",
    yes: "Ja",
    no: "Nei",
    depositsExceedCapacity:
      "De planlagte engangsinnskuddene overstiger beløpet tilgjengelig for investering. Reduser innskuddene eller juster kapasitetsgrunnlaget.",
    recurringDepositsExceedSurplus:
      "De planlagte månedlige innskuddene overstiger klientens månedlige overskudd. Reduser månedlig sparing eller juster kapasitetsgrunnlaget.",
    requiredFieldsMissing: "Fyll inn beløp for alle påkrevde felt (merket med *).",
    requiredFieldsMissingNamed: (fields: string) => `Fyll inn beløp for: ${fields}.`,
    baselineMissing: "Fyll inn minst ett inntekts- eller eiendelsbeløp før du fortsetter.",
    assetsRequired: "Minst én eiendel med beløp er påkrevd.",
    liabilitiesRequired: "Minst én gjeldspost med beløp er påkrevd.",
    expectingChangesUnanswered:
      "Svar på spørsmålet om forventede endringer i den økonomiske situasjonen.",
    expectingChangesNoteMissing: "Beskriv de forventede endringene i den økonomiske situasjonen.",
    capacityMissing: "Fyll ut Kapasitet-fanen (inntekt og utgifter).",
    bufferMissing:
      "Angi beløpet for den egendefinerte likviditetsbufferen i Kapasitet-fanen, eller velg minimum.",
    bufferBelowMinimum:
      "Likviditetsbufferen er under påkrevd minimum. Øk bufferen eller juster kapasitetsgrunnlaget.",
    fillFromEnin: "Fyll fra ENIN",
    fetchingFromEnin: "Henter fra ENIN…",
    eninFetchFailed: "Kunne ikke hente tall fra ENIN.",
    fromEnin: "Fra ENIN",
    groupNote: "Den finansielle situasjonen er basert på gruppens finansielle situasjon.",
  },
} as const;
